export default "__VITE_ASSET__CpiKUO8B__"